<script setup>
import { computed, ref, watch, inject } from 'vue';

const props = defineProps({
	min: { type: Number, default: 0 },
	max: { type: Number, default: 100 },
	step: { type: Number, default: 1 },
	modelValue: {
		type: Array,
		default: () => [],
	},
});

const emit = defineEmits(['update:modelValue']);
const { userInputState } = inject('userInputState')

const localMin = ref(props.modelValue[0]);
const localMax = ref(props.modelValue[1]);
// const inputMin = ref(props.min);
// const inputMax = ref(props.max);
const inputMin = ref(props.modelValue[0]);
const inputMax = ref(props.modelValue[1]);
let timeoutId = null;

//emit('update:modelValue', [localMin.value, localMax.value]);

const fillLeft = computed(() => ((localMin.value - props.min) / (props.max - props.min)) * 100);
const fillWidth = computed(() => {
	return ((localMax.value - localMin.value) / (props.max - props.min)) * 100
});

const isDisabled = computed(() => {
	return props.min === props.max
})

const handleMinInput = () => {
	if (localMin.value > localMax.value && localMax.value == props.max) {
		localMin.value = localMax.value;
	} else if(localMin.value > localMax.value) {
		localMax.value = localMin.value;
	}
	userInputState.value.year = true;
	emit('update:modelValue', [localMin.value, localMax.value]);
};

const handleMaxInput = () => {
	if (localMax.value < localMin.value) {
		localMax.value = localMin.value;
	}
	userInputState.value.year = true;
	emit('update:modelValue', [localMin.value, localMax.value]);
};

watch(() => props.modelValue,
	([newMin, newMax]) => {
		//delay setting ref field, needed to reset field after new indicator has been loaded
//		clearTimeout(timeoutId);
//		timeoutId = setTimeout(() => {
			localMin.value = inputMin.value = parseInt(newMin);
			localMax.value = inputMax.value = parseInt(newMax);
//		}, 300); // Wait 300ms after last change		
	}
);

const validateMinInput = () => {
	if(inputMin.value < props.min) inputMin.value = props.min;
	if(inputMin.value > inputMax.value ) inputMin.value = inputMax.value;
	localMin.value = inputMin.value

	handleMinInput()
}

const validateMaxInput = () => {
	if(inputMax.value > props.max) inputMax.value = props.max;
	if(inputMax.value < inputMin.value ) inputMax.value = inputMin.value ;
	localMax.value = inputMax.value
	handleMinInput()
}
</script>

<template>
	<div class="range-container">
		<input id="filter-input-range-min" type="number" aria-label="Min range input" class="range-input" maxlength="4" v-model="inputMin" :disabled="isDisabled" @change="validateMinInput()">
		<div class="range-wrapper">
			<input id="filter-range-min" type="range" aria-label="Min range slider handle" :min="min" :max="max" :step="step" v-model.lazy="localMin" :disabled="isDisabled" @change="handleMinInput"
				class="range-slider" />
			<input id="filter-range-max" type="range" aria-label="Max range slider handle" :min="min" :max="max" :step="step" v-model.lazy="localMax" :disabled="isDisabled" @change="handleMaxInput"
				class="range-slider" />
			<div class="range-track">
				<div class="range-fill" :style="{
					left: fillLeft + '%',
					width: fillWidth + '%'}">
				</div>
			</div>
		</div>
		<input id="filter-input-range-max" type="number" aria-label="Max range input" class="range-input" maxlength="4"  v-model="inputMax" :disabled="isDisabled" @change="validateMaxInput()">
	</div>
</template>

<style scoped>
.range-container {
	display: flex;
	width: 100%;
	padding:0.125rem;
}

.range-wrapper {
	position: relative;
	top: -0.125rem;
	left: -0.125rem;;
	width: 98%;
	height: 2.5rem;
	margin-left:0.1875em;
	margin-right: 0.1875em;	
}

.range-slider {
	position: absolute;
	width: 100%;
	height: 2.5rem;
	-webkit-appearance: none;
	background: none;
	pointer-events: none;
	z-index: 2;
}

.range-slider::-webkit-slider-thumb {
	pointer-events: auto;
	-webkit-appearance: none;
	height: 1.125rem;
	width: 1.125rem;
	background: var(--brand-color-DarkWhite);
	border-radius: 50%;
	border: 1px solid var(--brand-color-Grey);
	cursor: pointer;
	position: relative;
}

.range-slider::-moz-range-thumb {
	pointer-events: auto;
	height: 1.5rem;
	width: 1.5rem;
	background: var(--brand-color-IndicatorsBlue);
	border-radius: 50%;
	border: none;
	cursor: pointer;
	position: relative;
}

/* .range-slider:active {
	z-index: 5;
} */

#filter-range-min {
	z-index: 3;
}

#filter-range-max {
	z-index: 2;
}

 .range-input {
	width: 3.5rem;
}
/*
.range-input:focus {
    outline: 0;
} */

.range-track {
	position: absolute;
	top: 50%;
	left: 0px;
	height: 0.375rem;
	width: 98%;
	background-color: #ddd;
	transform: translateY(-50%);
	border-radius: 0.1875rem;
	z-index: 0;
	margin-left: 0.1875rem;
	margin-right: 0.1875rem;
}

.range-fill {
	position: absolute;
	height: 100%;
	background-color: var(--brand-color-IndicatorsBlue);
	border-radius: 0.1875rem;
	z-index: 1;
}

.range-slider:disabled {
	cursor: default;	
	color: var(--text-Secondary);
}

.range-slider:disabled + .range-tracker .range-fill {
	background-color: var(--text-Secondary)
}

.range-input:disabled {
	cursor: default;	
	color: var(--text-Secondary)
}
</style>
